import styles from "./ProjectCard.module.css";

import ProjectVideo from "./ProjectVideo";
import ProjectContent from "./ProjectContent";

const ProjectCard = (props) => {
  const style = `${styles["project-card"]} ${
    props.currentState === "EXIT" && styles["project-card--exit"]
  }`;

  return (
    props.currentState !== "DESTROYED" && (
      <div className={style}>
        <ProjectVideo id={props.project.id} currentState={props.currentState} />
        <ProjectContent
          project={props.project}
          currentState={props.currentState}
        />
      </div>
    )
  );
};

export default ProjectCard;
